import React, { useEffect } from 'react';
import { Icon } from '@iconify/react';
import { Link } from 'react-router-dom';
import { useFormResponseStore } from '@/store';

interface AddURLProps {
  question: any;
  sectionId: string;
  sectionName: string;
}

export const AddURLAnswer: React.FC<AddURLProps> = ({ question, sectionId, sectionName }) => {
  const { setResponse } = useFormResponseStore();

  useEffect(() => {
    if (question.urlName) {
      setResponse(
        sectionId,
        sectionName,
        question.id,
        question.type,
        question.label || '',
        {
          urlName: question.urlName,
          label: question.label
        }
      );
    }
  }, [question.id, question.type, question.label, question.urlName, sectionId, sectionName, setResponse]);

  return (
    <div className="flex items-center space-x-2"> 
      <div className='p-2 rounded bg-subprimary'>
        <Icon icon="mingcute:link-fill" className='text-textIcon' />
      </div>
      <Link to={question.urlName} target="_blank" rel="noopener noreferrer" className="main-label truncate max-w-[240px] overflow-hidden text-ellipsis text-sm hover:underline hover:text-darkBlue">
        {question.label}
      </Link>
  </div>
  );
};